import store from "../store";
import rootModule from "../store/modules/root-module";

export default function RootMiddleware({ next, router }) {
  try {
    let userToken = localStorage.getItem("token");
    let userRole = localStorage.getItem("user_role");
    if (!userToken) {
      return router.push({ name: "login" });
    }
    if (userRole === "root") {
      if (!store.hasModule("root")) store.registerModule("root", rootModule);
      return next();
    } else {
      return router.push({ name: "login" });
    }
  } catch (err) {
    return router.push({ name: "login" });
  }
}
